import './member.css';

import * as React from 'react';
import { Link } from 'react-router-dom';
import Constants from 'src/common/Constants';
import Group from 'src/entities/Group';

interface IProps {
  function?: string;
  group?: Group;
}

class Navigation extends React.Component<IProps> {
  constructor(props: any) {
    super(props);
  }

  render() {
    if (this.props.group !== undefined) {
      const group = this.props.group as Group;
      const functions: number[] = [];
      this.props.group.functions
        .filter(f => ![Constants.FUNCTION_MEMO_NOTIFICATION].includes(f))
        .sort((a, b) => (a < b ? -1 : 1))
        .forEach((functionId, index) => {
          if (index > 0) {
            functions.push(0);
          }
          functions.push(functionId);
        });

      return (
        <div id="NavigationMember">
          {functions.map((functionId, index) => {
            if (0 === functionId) {
              return <div key={index} className="Bar" />;
            }

            if (Constants.FUNCTION_MEMO === functionId) {
              return (
                <Link key={index} to={'/' + group.title + '/memos'}>
                  <span
                    className={
                      this.props.function === 'memo'
                        ? 'Function FunctionSelected'
                        : 'Function'
                    }
                  >
                    メモ
                  </span>
                </Link>
              );
            }

            if (Constants.FUNCTION_WIKI === functionId) {
              return (
                <Link key={index} to={'/' + group.title + '/wikis'}>
                  <span
                    className={
                      this.props.function === 'wiki'
                        ? 'Function FunctionSelected'
                        : 'Function'
                    }
                  >
                    ウィキ
                  </span>
                </Link>
              );
            }

            if (Constants.FUNCTION_NOTE === functionId) {
              return (
                <Link key={index} to={'/' + group.title + '/notes'}>
                  <span
                    className={
                      this.props.function === 'note'
                        ? 'Function FunctionSelected'
                        : 'Function'
                    }
                  >
                    ノート
                  </span>
                </Link>
              );
            }

            if (Constants.FUNCTION_BOARD === functionId) {
              return (
                <Link key={index} to={'/' + group.title + '/boards'}>
                  <span
                    className={
                      this.props.function === 'board'
                        ? 'Function FunctionSelected'
                        : 'Function'
                    }
                  >
                    ボード
                  </span>
                </Link>
              );
            }

            return null;
          })}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/member.tsx